module.exports = __webpack_public_path__ + "img/autorizaciones.8563ea48.svg";